<template>
  <b-btn class="SpinnerButton" v-bind="$attrs" @click="$emit('click', $event)">
    <span :style="{ opacity: loading ? 0 : 1 }"><slot /></span>
    <spinner v-if="loading" :size="20" />
  </b-btn>
</template>

<script>
import Spinner from '@/components/utility/Spinner';

export default {
  name: 'SpinnerButton',
  props: {
    loading: Boolean,
  },
  components: {
    Spinner,
  },
};
</script>

<style lang="scss">
.SpinnerButton {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/utility/SpinnerButton.vue